<template>
  <header class="w-full h-full px-5 flex items-center border-b border-gray-200 justify-between">
    <!-- 左侧 Brand -->
    <!-- <div class="flex-none w-[40px] sm:w-[140px] h-full">
      <Brand />
    </div> -->

    <!-- 中间导航 -->
    <div class="hidden sm:flex flex-auto justify-center overflow-x-auto">
      <Siders v-show="!showLoginedMenu" />
    </div>

    <!-- 添加移动端博客导航项 -->
    <div class="sm:hidden flex items-center justify-center flex-auto h-full">
      <Siders mode="mobile" />
    </div>

    <!-- 右侧 -->
    <!-- <div class="hidden sm:flex flex-none w-300px justify-end items-center">
      <Notify v-if="isLoggedIn" />
      <Lang v-if="hideFooter" />
      <User v-if="!hideFooter" />
    </div> -->

    <!-- 移动端按钮 -->
    <a-button class="sm:hidden ml-2" type="text" @click="open">
      <MenuOutlined />
    </a-button>

    <a-drawer v-model:open="drawerVisible" placement="right" width="240">
      <Siders direction="vertical" @clicked="close" v-show="!showLoginedMenu" />
      <!-- <VMenu v-show="showLoginedMenu" @clicked="close" />
      <template v-if="isLoggedIn">
        <a-divider></a-divider>
        <Notify v-if="isLoggedIn" @goto="close" />
      </template>
      <a-divider></a-divider>
      <User @goto="close" />
      <a-divider></a-divider>
      <Lang @change="close" /> -->
    </a-drawer>
  </header>
</template>

<script setup lang="ts">
const { showLoginedMenu } = useMenus();
const userStore = useUserStore();
const { isLoggedIn } = storeToRefs(userStore);
const route = useRoute();
const hideFooter = computed(() => !!route.meta.hideFooter);

const drawerVisible = ref(false);
const open = () => {
  drawerVisible.value = true;
};
const close = () => {
  drawerVisible.value = false;
};
</script>
